import React, { useState, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';
import { useOrganization } from "../../../context/OrgContext";

const GeneralSettings = () => {
  const { institution } = useOrganization();
  const [formData, setFormData] = useState({
    handle: '',
    domain: '',
    fullName: '',
    location: '',
  });

  const [isSaving, setIsSaving] = useState(false);
  const [status, setStatus] = useState({ success: '', error: '' });

  useEffect(() => {
    if (institution) {
      setFormData({
        handle: institution.handle || '',
        domain: institution.domain || '',
        fullName: institution.fullName || '',
        location: institution.location || '',
      });
    }
  }, [institution]);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setStatus({ success: '', error: '' });
    setIsSaving(true);

    try {
      await updateDoc(doc(db, 'colleges', formData.domain), {
        fullName: formData.fullName,
        location: formData.location,
        updatedAt: new Date().toISOString()
      });

      setStatus({ success: 'Settings updated successfully.', error: '' });
    } catch (error) {
      console.error('Error updating settings:', error);
      setStatus({ success: '', error: 'Failed to update settings. Try again.' });
    }

    setIsSaving(false);
  };

  return (
    <div className="w-full mt-6 py-6">
      {status.success && (
        <div className="mb-4 p-3 bg-green-600/20 border border-green-400 text-green-100 rounded-lg text-sm text-center">
          {status.success}
        </div>
      )}
      {status.error && (
        <div className="mb-4 p-3 bg-red-600/20 border border-red-400 text-red-100 rounded-lg text-sm text-center">
          {status.error}
        </div>
      )}

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white mb-1">University Handle</label>
          <input
            type="text"
            value={formData.handle}
            disabled
            className="w-full p-3 bg-[#2a1a1e]/30 text-white/50 border border-[#3a2a2e]/50 rounded-lg cursor-not-allowed"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-1">Email Domain</label>
          <input
            type="text"
            value={formData.domain}
            disabled
            className="w-full p-3 bg-[#2a1a1e]/30 text-white/50 border border-[#3a2a2e]/50 rounded-lg cursor-not-allowed"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-1">Full University Name</label>
          <input
            type="text"
            value={formData.fullName}
            onChange={(e) => handleChange('fullName', e.target.value)}
            className="w-full p-3 bg-[#1a1416]/40 text-white border border-[#3a2a2e]/50 rounded-lg"
            placeholder="e.g., Harvard University"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-1">Location</label>
          <input
            type="text"
            value={formData.location}
            onChange={(e) => handleChange('location', e.target.value)}
            className="w-full p-3 bg-[#1a1416]/40 text-white border border-[#3a2a2e]/50 rounded-lg"
            placeholder="e.g., Cambridge, MA"
          />
        </div>

        <button
          onClick={handleSave}
          disabled={isSaving}
          className="w-full py-3 mt-4 bg-gradient-to-r from-[#B0276E]/80 to-[#8a1f57]/80 hover:from-[#B0276E] hover:to-[#8a1f57] text-white font-semibold rounded-lg transition-all duration-300 disabled:opacity-50"
        >
          {isSaving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
};

export default GeneralSettings;
